// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Caml_obj = require("rescript/lib/js/caml_obj.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Expln_React_Row = require("@expln/utils/src/main/Expln_React_Row.bs.js");
var Box = require("@mui/material/Box").default;
var Expln_React_common = require("@expln/utils/src/main/Expln_React_common.bs.js");
var Expln_utils_common = require("@expln/utils/src/main/Expln_utils_common.bs.js");
var Select = require("@mui/material/Select").default;
var Slider = require("@mui/material/Slider").default;
var Checkbox = require("@mui/material/Checkbox").default;
var MenuItem = require("@mui/material/MenuItem").default;
var TextField = require("@mui/material/TextField").default;
var InputLabel = require("@mui/material/InputLabel").default;
var FormControl = require("@mui/material/FormControl").default;

function rndParam(paramName, defaultValue, value, setValue, rndValue) {
  return React.createElement(Expln_React_Row.make, {
              alignItems: "center",
              spacing: 2,
              children: null
            }, React.createElement(Checkbox, {
                  checked: Belt_Option.isSome(value),
                  onChange: (function (param) {
                      return Expln_React_common.evt2bool((function (checked) {
                                    Curry._1(setValue, checked ? Caml_option.some(defaultValue) : undefined);
                                  }), param);
                    })
                }), paramName, Curry._1(rndValue, undefined));
}

function rndStringParam(paramName, defaultValue, value, setValue) {
  return rndParam(paramName, defaultValue, value, setValue, (function (param) {
                return React.createElement(TextField, {
                            value: Belt_Option.getWithDefault(value, ""),
                            onChange: (function (param) {
                                return Expln_React_common.evt2str(setValue, param);
                              }),
                            disabled: Belt_Option.isNone(value)
                          });
              }));
}

function rndBoolParam(paramName, defaultValue, value, setValue) {
  return rndParam(paramName, defaultValue, value, setValue, (function (param) {
                return null;
              }));
}

function rndIntSliderParam(paramName, defaultValue, value, setValue, min, max, step) {
  return rndParam(paramName, defaultValue, value, setValue, (function (param) {
                return React.createElement(Box, {
                            sx: {
                              width: 300
                            },
                            children: React.createElement(Slider, {
                                  size: "small",
                                  defaultValue: defaultValue,
                                  valueLabelDisplay: "auto",
                                  min: min,
                                  max: max,
                                  step: step,
                                  disabled: Belt_Option.isNone(value),
                                  onChange: (function (param, v) {
                                      Curry._1(setValue, v | 0);
                                    })
                                })
                          });
              }));
}

function strToVal(paramNameOpt, possibleValues, str) {
  var paramName = paramNameOpt !== undefined ? paramNameOpt : "unknown-parameter";
  var val = Belt_Option.map(Belt_Array.getBy(possibleValues, (function (param) {
              return param[1] === str;
            })), (function (param) {
          return param[0];
        }));
  if (val !== undefined) {
    return Caml_option.valFromOption(val);
  } else {
    return Expln_utils_common.exn("Could not transform the string representation '" + str + "' of '" + paramName + "' parameter to actual value.");
  }
}

function valToStr(paramNameOpt, possibleValues, val) {
  var paramName = paramNameOpt !== undefined ? paramNameOpt : "unknown-parameter";
  var str = Belt_Option.map(Belt_Array.getBy(possibleValues, (function (param) {
              return Caml_obj.equal(param[0], val);
            })), (function (param) {
          return param[1];
        }));
  if (str !== undefined) {
    return str;
  } else {
    return Expln_utils_common.exn("Could not determine string representation for the value '" + Expln_utils_common.stringify(val) + "' of '" + paramName + "' parameter.");
  }
}

function valToCode(paramNameOpt, possibleValues, val) {
  var paramName = paramNameOpt !== undefined ? paramNameOpt : "unknown-parameter";
  var code = Belt_Option.map(Belt_Array.getBy(possibleValues, (function (param) {
              return Caml_obj.equal(param[0], val);
            })), (function (param) {
          return param[2];
        }));
  if (code !== undefined) {
    return code;
  } else {
    return Expln_utils_common.exn("Could not determine code representation for the value '" + Expln_utils_common.stringify(val) + "' of '" + paramName + "' parameter.");
  }
}

function rndEnumParam(paramName, defaultValue, value, setValue, possibleValues) {
  var labelId = "select-label-for-" + paramName;
  return rndParam(paramName, defaultValue, value, setValue, (function (param) {
                return React.createElement(FormControl, {
                            disabled: Belt_Option.isNone(value),
                            children: null
                          }, React.createElement(InputLabel, {
                                id: labelId,
                                children: paramName
                              }), React.createElement(Select, {
                                labelId: labelId,
                                label: paramName,
                                value: value !== undefined ? valToStr(paramName, possibleValues, Caml_option.valFromOption(value)) : valToStr(paramName, possibleValues, defaultValue),
                                onChange: (function (param) {
                                    return Expln_React_common.evt2str((function (str) {
                                                  Curry._1(setValue, Caml_option.some(strToVal(paramName, possibleValues, str)));
                                                }), param);
                                  }),
                                children: possibleValues.map(function (param) {
                                      var s = param[1];
                                      return React.createElement(MenuItem, {
                                                  value: s,
                                                  children: s,
                                                  key: s
                                                });
                                    })
                              }));
              }));
}

function strOrNull(__x) {
  return Belt_Option.getWithDefault(__x, "");
}

exports.rndParam = rndParam;
exports.rndStringParam = rndStringParam;
exports.rndBoolParam = rndBoolParam;
exports.rndIntSliderParam = rndIntSliderParam;
exports.strToVal = strToVal;
exports.valToStr = valToStr;
exports.valToCode = valToCode;
exports.rndEnumParam = rndEnumParam;
exports.strOrNull = strOrNull;
/* react Not a pure module */
